import script from "./CurrencyField.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyField.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyField.vue?vue&type=style&index=0&id=5be799e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be799e0"]])

export default __exports__